import axios from 'axios';
import { EnumService } from 'common/service';
import { extractEntidadeFromPath } from 'common/utils';
import { ProtocoloAuthService } from 'service';
import { getEntidadeByPathname, getToken } from 'utils';

const MODULO_PROTOCOLO = '4';
const EXERCICIO_DEFAULT = new Date().getFullYear();

axios.interceptors.request.use(config => {
  const url = typeof config.url === 'string' ? config.url : '';
  if (!url.startsWith('/painel-api/')) {
    return config;
  }
  const TOKEN = getToken();
  if (TOKEN) {
    config.headers['Authorization'] = `Bearer ${TOKEN}`;
  }

  return config;
});

const axiosInstance = axios.create({
  baseURL: '/protocolo-api/api',
  headers: {
    Accept: 'application/json, application/pdf;q=0.9, */*;q=0.8',
    'Content-Type': 'application/json',
    modulo: MODULO_PROTOCOLO
  }
});

axiosInstance.interceptors.request.use(async config => {
  const { ...newConfig } = config;

  const TOKEN = getToken();

  const ENTIDADE = Number(
    extractEntidadeFromPath()?.idEntidade || getEntidadeByPathname() || 0
  );

  if (TOKEN) {
    newConfig.headers['Authorization'] = `Bearer ${TOKEN}`;
  }
  if (ENTIDADE) {
    newConfig.headers['entidade'] = ENTIDADE;
  }
  newConfig.headers['exercicio'] = EXERCICIO_DEFAULT;
  newConfig.headers['modulo'] = MODULO_PROTOCOLO;
  newConfig.headers['x-tenant-host'] = window.location.host;
  newConfig.headers['ACTIVE_VIEW'] = window.location.pathname;

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  newConfig.headers['X-Timezone'] = timezone;

  return Promise.resolve(newConfig);
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      ProtocoloAuthService.clearAuthentication();
      window.location.href = '/';
    } else {
      return Promise.reject(error);
    }
  }
);

EnumService.setAxiosInstance(axiosInstance);

export default axiosInstance;
